export  default {

}
export const province = [{
	label: '市内城市',
	options: [{
		value: '成都市',
		label: '成都市'
	}, {
		value: '杭州市',
		label: '杭州市'
	}]
	}, {
	label: '省份',
	options: [{
		value: '四川省',
		label: '四川省'
	}, {
		value: '浙江省',
		label: '浙江省'
	}, {
		value: '北京市',
		label: '北京市'
	}, {
		value: '天津市',
		label: '天津市'
	}, {
		value: '上海市',
		label: '上海市'
	}, {
		value: '重庆市',
		label: '重庆市'
	}, {
		value: '河北省',
		label: '河北省'
	}, {
		value: '河南省',
		label: '河南省'
	}, {
		value: '云南省',
		label: '云南省'
	}, {
		value: '辽宁省',
		label: '辽宁省'
	}, {
		value: '黑龙江省',
		label: '黑龙江省'
	}, {
		value: '湖南省',
		label: '湖南省'
	}, {
		value: '安徽省',
		label: '安徽省'
	}, {
		value: '山东省',
		label: '山东省'
	}, {
		value: '新疆维吾尔',
		label: '新疆维吾尔'
	}, {
		value: '江苏省',
		label: '江苏省'
	}, {
		value: '江西省',
		label: '江西省'
	}, {
		value: '湖北省',
		label: '湖北省'
	}, {
		value: '广西壮族',
		label: '广西壮族'
	}, {
		value: '甘肃省',
		label: '甘肃省'
	}, {
		value: '山西省',
		label: '山西省'
	}, {
		value: '内蒙古',
		label: '内蒙古'
	}, {
		value: '陕西省',
		label: '陕西省'
	}, {
		value: '吉林省',
		label: '吉林省'
	}, {
		value: '福建省',
		label: '福建省'
	}, {
		value: '贵州省',
		label: '贵州省'
	}, {
		value: '广东省',
		label: '广东省'
	}, {
		value: '青海省',
		label: '青海省'
	}, {
		value: '西藏',
		label: '西藏'
	}, {
		value: '宁夏回族',
		label: '宁夏回族'
	}, {
		value: '海南省',
		label: '海南省'
	}, {
		value: '台湾',
		label: '台湾'
	}, {
		value: '香港特别行政区',
		label: '香港特别行政区'
	}, {
		value: '澳门特别行政区',
		label: '澳门特别行政区'
	}]
}]